import type { ReactNode } from 'react';

import { Box } from 'app/shopify/theme';

import { ThumbnailFrame, type ThumbnailImageSize, type ThumbnailShape } from './ThumbnailFrame';

export interface ThumbnailBrandProps {
  shape?: ThumbnailShape;
  size?: ThumbnailImageSize;
  /** Logo content fills the thumbnail. Keep artwork sizing/aspect ratio inside this slot. */
  children?: ReactNode;
  accessibilityLabel?: string;
  testID?: string;
}

export function ThumbnailBrand({ shape = 'square', size = 120, children, ...accessibility }: ThumbnailBrandProps) {
  return (
    <ThumbnailFrame {...accessibility} size={size} shape={shape} media border backgroundColor="surface.tertiary">
      <Box
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="center"
        accessibilityElementsHidden
        importantForAccessibility="no-hide-descendants"
      >
        {children}
      </Box>
    </ThumbnailFrame>
  );
}
